<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"s
            :main_icon="main_icon"
            :bgColor="bgColor"
            :icons="icon_data"
            :load_url="load_url"
            :base-col-len="12"
            :hasLinks="hasLinks"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'ReturnFlags',
        components: {DashboardCard},
        props: {
            dataDisplay: {type:String, default: null},
            bgColor: {type: String, default: 'light'},
            width: {type: Number, default: 25}
        },
        data() {
            return {
                hasLinks: true,
                main_icon: 'fa-light fa-flag',
                color: '#d53a00',
                title: 'Return Flags',
                load_url: '/dashboards/ReturnFlags',
                icon_data: [
                    {
                        name: 'Returns Undeliverable',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=13',
                        text_color: '#d53a00'
                    },
                    {
                        name: 'Non-Precious Returns',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=15&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12',
                        text_color: '#d53a00'
                    },
                    {
                        name: 'Returns Expedite',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=16&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12&filterField_2=status_id&filterModel_2=order&filterName_2=Order%20Status&filterParameter_2=not%20equal%20to&filterValue_2=13&filterField_3=status_id&filterModel_3=order&filterName_3=Order%20Status&filterParameter_3=not%20equal%20to&filterValue_3=14&filterField_4=status_id&filterModel_4=order&filterName_4=Order%20Status&filterParameter_4=not%20equal%20to&filterValue_4=15',
                        text_color: '#d53a00'
                    },
                    {
                        name: 'Compliance Return',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=58',
                        text_color: '#d53a00'
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>